if (!customElements.get('nizam-story')) {
  customElements.define('nizam-story', class extends HTMLElement {
    connectedCallback() {
      // On editor reloads the element can connect before its children arrive.
      this.markupObserver = new MutationObserver(() => this.initialize());
      this.markupObserver.observe(this, { childList: true, subtree: true });
      this.initialize();
    }

    initialize() {
      if (this.abortController) return;
      const purchase = this.querySelector('[data-nizam-purchase] button[type="submit"]');
      const sticky = this.querySelector('[data-nizam-sticky]');
      if (!purchase || !sticky) return;
      this.markupObserver.disconnect();
      this.abortController = new AbortController();
      const header = document.querySelector('.shopify-section--header');
      const update = () => {
        this.frame = null;
        const previewToolbar = document.getElementById('PBarNextFrameWrapper');
        const previewRect = previewToolbar?.getBoundingClientRect();
        const previewOffset = previewRect?.height ? Math.max(0, window.innerHeight - previewRect.top) : 0;
        document.documentElement.style.setProperty('--nizam-preview-offset', `${previewOffset}px`);
        const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
        // Hand over as soon as the inline button begins slipping under the header.
        sticky.hidden = purchase.getBoundingClientRect().top >= headerBottom;
        if (!sticky.hidden && sticky.offsetHeight) {
          document.documentElement.style.setProperty('--nizam-sticky-height', `${sticky.offsetHeight}px`);
        }
      };
      const scheduleUpdate = () => {
        if (this.frame == null) this.frame = requestAnimationFrame(update);
      };
      const options = { passive: true, signal: this.abortController.signal };
      const gallery = this.querySelector('[data-nizam-gallery]');
      const viewLinks = Array.from(this.querySelectorAll('[data-nizam-view]'));
      if (gallery && viewLinks.length) {
        const setCurrentView = () => {
          const index = Math.round(gallery.scrollLeft / gallery.clientWidth);
          viewLinks.forEach((link, i) => {
            if (i === index) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
        };
        viewLinks.forEach((link, index) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            gallery.scrollTo({ left: index * gallery.clientWidth, behavior: 'instant' });
            setCurrentView();
          }, { signal: this.abortController.signal });
        });
        gallery.addEventListener('scroll', setCurrentView, options);
        // Keep the selected view when the responsive gallery changes width.
        this.galleryResizeObserver = new ResizeObserver(() => {
          const index = Math.max(0, viewLinks.findIndex(link => link.getAttribute('aria-current') === 'true'));
          gallery.scrollLeft = index * gallery.clientWidth;
        });
        this.galleryResizeObserver.observe(gallery);
      }

      this.querySelectorAll('[data-story-carousel]').forEach((carousel) => {
        const views = Array.from(carousel.parentElement.querySelectorAll('[data-story-carousel-view]'));
        if (!views.length) return;
        const setCurrentView = () => {
          const index = Math.round(carousel.scrollLeft / carousel.clientWidth);
          views.forEach((view, i) => {
            if (i === index) view.setAttribute('aria-current', 'true');
            else view.removeAttribute('aria-current');
          });
        };
        views.forEach((view, index) => {
          view.addEventListener('click', (event) => {
            event.preventDefault();
            carousel.scrollTo({ left: index * carousel.clientWidth, behavior: 'smooth' });
          }, { signal: this.abortController.signal });
        });
        carousel.addEventListener('scroll', setCurrentView, options);
      });

      window.addEventListener('scroll', scheduleUpdate, options);
      window.addEventListener('resize', scheduleUpdate, options);
      window.addEventListener('pageshow', scheduleUpdate, options);
      window.visualViewport?.addEventListener('resize', scheduleUpdate, options);
      this.resizeObserver = new ResizeObserver(scheduleUpdate);
      this.resizeObserver.observe(purchase);
      this.resizeObserver.observe(sticky);
      if (header) this.resizeObserver.observe(header);
      // Shopify inserts its hosted draft-preview toolbar after the page loads.
      const observePreviewToolbar = () => {
        const toolbar = document.getElementById('PBarNextFrameWrapper');
        if (toolbar && toolbar !== this.previewToolbar) {
          if (this.previewToolbar) this.resizeObserver.unobserve(this.previewToolbar);
          this.previewToolbar = toolbar;
          this.resizeObserver.observe(toolbar);
          toolbar.addEventListener('toggle', scheduleUpdate, { signal: this.abortController.signal });
        }
        scheduleUpdate();
      };
      this.previewObserver = new MutationObserver(observePreviewToolbar);
      this.previewObserver.observe(document.body, { childList: true });
      observePreviewToolbar();
      scheduleUpdate();
    }

    disconnectedCallback() {
      this.markupObserver?.disconnect();
      this.previewObserver?.disconnect();
      this.previewToolbar = null;
      this.resizeObserver?.disconnect();
      this.galleryResizeObserver?.disconnect();
      this.abortController?.abort();
      this.abortController = null;
      cancelAnimationFrame(this.frame);
      this.frame = null;
      document.documentElement.style.removeProperty('--nizam-sticky-height');
      document.documentElement.style.removeProperty('--nizam-preview-offset');
    }
  });
}
